import { createAction, handleActions } from 'redux-actions';
import { _getFeedingInfo, _updateFeedingInfo } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  feeding_info: { loading: false, response: [], hasError: false, error: {} },
};
//FEEDING_INFO LIST
export const getFeedingInfoStart = createAction(ActionTypes.GET_FEEDING_INFO);
export const getFeedingInfoSuccess = createAction(ActionTypes.GET_FEEDING_INFO_SUCCESS, response => response);
export const getFeedingInfoError = createAction(ActionTypes.GET_FEEDING_INFO_ERROR, error => error);

export const getFeedingInfo = (page = '') => (dispatch) => {
  dispatch(getFeedingInfoStart());
  return _getFeedingInfo(page).then((response) => {
    dispatch(getFeedingInfoSuccess(response));
  }).catch((error) => {
    dispatch(getFeedingInfoError(error));
  });
};

//UPDATE FEEDING_INFO
export const updateFeedingInfoStart = createAction(ActionTypes.UPDATE_FEEDING_INFO);
export const updateFeedingInfoSuccess = createAction(ActionTypes.UPDATE_FEEDING_INFO_SUCCESS, response => response);
export const updateFeedingInfoError = createAction(ActionTypes.UPDATE_FEEDING_INFO_ERROR, error => error);

export const updateFeedingInfo = (data) => (dispatch) => {
  dispatch(updateFeedingInfoStart());
  return _updateFeedingInfo(data).then((response) => {
    dispatch(updateFeedingInfoSuccess(data, response));
  }).catch((error) => {
    dispatch(updateFeedingInfoError(error));
  });
};

const reducer = handleActions({
  //FEEDING_INFO_LIST
  [ActionTypes.GET_FEEDING_INFO]: (state) => ({
    ...state, feeding_info: {
      ...state.feeding_info,
      loading: true, hasError: false, error: {}
    },
  }),
  [ActionTypes.GET_FEEDING_INFO_SUCCESS]: (state, action) => (
    {
      ...state,
      feeding_info: {
        ...state.feeding_info,
        response: action.payload, loading: false, hasError: false, error: {}
      },
    }),
  [ActionTypes.GET_FEEDING_INFO_ERROR]: (state, action) => ({
    ...state,
    feeding_info: {
      ...state.feeding_info,
      error: action.payload, loading: false, hasError: true, response: {}
    },
  }),
  //UPDATE_FEEDING_INFO
  [ActionTypes.UPDATE_FEEDING_INFO]: (state) => ({
    ...state,
    feeding_info: {
      ...state.feeding_info,
      loading: true, hasError: false, error: {}
    },
  }),
  [ActionTypes.UPDATE_FEEDING_INFO_SUCCESS]: (state, action) => ({
    ...state,
    feeding_info: {
      ...state.feeding_info,
      response: action.payload,
      loading: false, hasError: false, error: {}
    },
  }),
  [ActionTypes.UPDATE_FEEDING_INFO_ERROR]: (state) => ({
    ...state,
    feeding_info: {
      ...state.feeding_info,
      loading: false, hasError: true, error: {}
    },
  })

}, initialState);

export default reducer;
